import { create } from "zustand";

/**
 * プライベートメモ管理ダイアログ（PrivateNotesManager）の開閉状態
 *
 * 正式な置き場は設定ページの「メモ」タブ。このダイアログは、メモポップオーバーの
 * 暗号化案内や暗号化ナッジから「ページを離れずに」設定するための導線で、
 * ダイアログ本体はヘッダーにマウントされている（離れた場所から開くため global store）
 */
interface NotesManagerState {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

export const useNotesManagerStore = create<NotesManagerState>((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
}));
